export default "__VITE_ASSET__BElb3Khp__"